<template>
  <div
    class="card"
    :class="{
      details: isFocused,
      'selection-mode': isSelectionModeEnabled,
      disabledParcelshop: disabledParcelshop,
    }"
    v-show="isVisible"
    @click="selectParcelshop(parcelshop)"
  >
    <div
      class="card-body"
      :class="{
        'locker-card-body': isLocker(parcelshop),
        'parcelshop-card-body': !isLocker(parcelshop),
        selected: selectedParcelshopId === parcelshop.Numero,
      }"
      :data-codeNature="parcelshop.CodeNature"
    >
      <span
        v-if="!parcelshop.isUnavailable"
        class="pickup-selector"
        :class="{ selected: selectedParcelshopId === parcelshop.Numero }"
        tabindex="0"
        @click.prevent="selectParcelshop(parcelshop)"
        @keydown.enter.prevent="selectParcelshop(parcelshop)"
        @keydown.space.prevent="selectParcelshop(parcelshop)"
      ></span>
      <div v-if="isPriceModeEnabled" class="card-number card-number--price">
        {{ price }} €
      </div>
      <div
        v-else
        class="card-number"
        :class="{ 'card-number--price': isPriceModeEnabled }"
      >
        {{ parcelshop.Adresse.Pays.Code }}-{{
          parcelshop.Numero.toString().padStart(5, "0")
        }}
      </div>
      <div class="card-container">
        <div>
          <template v-if="isAmazonLocker(parcelshop)">
            <AmazonLockerIcon />
          </template>
          <template v-else-if="parcelshop.CodeNature == 'C'">
            <LockerIcon />
          </template>
          <template v-else>
            <ParcelshopIcon />
          </template>
        </div>
        <div>
          <div
            class="card-title"
            :class="{ 'card-title--amazon': isAmazonLocker(parcelshop) }"
          >
            <!-- <span class="parcelshop-number">{{ parcelshopNumber }}</span> -->

            {{ parcelshop.Adresse.Libelle }}
          </div>
          <div class="card-text">
            <div v-if="!disabledParcelshop">
              {{ parcelshop.Adresse.AdresseLigne1 }}
            </div>
            <div v-if="!disabledParcelshop">
              {{ parcelshop.Adresse.CodePostal }} {{ parcelshop.Adresse.Ville }}
            </div>
            <div v-else class="bold">
              {{
                $t(
                  "parcelshopPicker.parcelshopLockerSelectionCard.unavailableParcelshop"
                )
              }}
            </div>
          </div>
        </div>
      </div>
      <div v-if="parcelshop.isUnavailable" class="unavailable">
        <!-- <span class="icon-cancel"></span>  -->
        <svg
          class="icon-cancel"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          width="10"
          height="10"
          viewBox="0 0 16 16"
        >
          <path
            d="M13.657 2.343c-1.511-1.511-3.52-2.343-5.657-2.343s-4.146 0.832-5.657 2.343c-1.511 1.511-2.343 3.52-2.343 5.657s0.832 4.146 2.343 5.657c1.511 1.511 3.52 2.343 5.657 2.343s4.146-0.832 5.657-2.343c1.511-1.511 2.343-3.52 2.343-5.657s-0.832-4.146-2.343-5.657zM14 8c0 1.294-0.412 2.494-1.111 3.475l-8.364-8.364c0.981-0.699 2.181-1.111 3.475-1.111 3.308 0 6 2.692 6 6zM2 8c0-1.294 0.412-2.494 1.111-3.475l8.364 8.364c-0.981 0.699-2.181 1.111-3.475 1.111-3.308 0-6-2.692-6-6z"
          ></path>
        </svg>
        {{ $t("parcelshopPicker.parcelshopList.unavailable") }}
      </div>
      <template v-if="this.$store.state.isCountryPrintInStore && !isAmazonLocker(parcelshop)">
        <div v-if="isPrintInStore(parcelshop)" class="card-footer">
          <!-- <span class="icon-qrcode"></span> -->
          <svg
            class="icon-qrcode"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            width="27"
            height="27"
            viewBox="0 0 16 16"
          >
            <path
              d="M5 1h-4v4h4v-4zM6 0v0 6h-6v-6h6zM2 2h2v2h-2zM15 1h-4v4h4v-4zM16 0v0 6h-6v-6h6zM12 2h2v2h-2zM5 11h-4v4h4v-4zM6 10v0 6h-6v-6h6zM2 12h2v2h-2zM7 0h1v1h-1zM8 1h1v1h-1zM7 2h1v1h-1zM8 3h1v1h-1zM7 4h1v1h-1zM8 5h1v1h-1zM7 6h1v1h-1zM7 8h1v1h-1zM8 9h1v1h-1zM7 10h1v1h-1zM8 11h1v1h-1zM7 12h1v1h-1zM8 13h1v1h-1zM7 14h1v1h-1zM8 15h1v1h-1zM15 8h1v1h-1zM1 8h1v1h-1zM2 7h1v1h-1zM0 7h1v1h-1zM4 7h1v1h-1zM5 8h1v1h-1zM6 7h1v1h-1zM9 8h1v1h-1zM10 7h1v1h-1zM11 8h1v1h-1zM12 7h1v1h-1zM13 8h1v1h-1zM14 7h1v1h-1zM15 10h1v1h-1zM9 10h1v1h-1zM10 9h1v1h-1zM11 10h1v1h-1zM13 10h1v1h-1zM14 9h1v1h-1zM15 12h1v1h-1zM9 12h1v1h-1zM10 11h1v1h-1zM12 11h1v1h-1zM13 12h1v1h-1zM14 11h1v1h-1zM15 14h1v1h-1zM10 13h1v1h-1zM11 14h1v1h-1zM12 13h1v1h-1zM13 14h1v1h-1zM10 15h1v1h-1zM12 15h1v1h-1zM14 15h1v1h-1z"
            ></path>
          </svg>
          <span>{{ $t("parcelshopPicker.parcelshopList.qrCode") }}</span>
        </div>
        <div v-else class="card-footer">
          <!--<span class="icon-barcode"></span>-->
          <!-- <svg class="icon-barcode" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="27" height="27" viewBox="0 0 16 16">
            <path d="M0 2h2v10h-2zM3 2h1v10h-1zM5 2h1v10h-1zM8 2h1v10h-1zM12 2h1v10h-1zM15 2h1v10h-1zM10 2h0.5v10h-0.5zM7 2h0.5v10h-0.5zM13.5 2h0.5v10h-0.5zM0 13h1v1h-1zM3 13h1v1h-1zM5 13h1v1h-1zM10 13h1v1h-1zM15 13h1v1h-1zM12 13h2v1h-2zM7 13h2v1h-2z"></path>
          </svg> -->
          <svg
            class="icon-barcode"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            width="27"
            height="27"
            viewBox="0 0 16 16"
          >
            <path d="M4 1h8v2h-8v-2z"></path>
            <path
              d="M15 4h-14c-0.55 0-1 0.45-1 1v5c0 0.55 0.45 1 1 1h3v4h8v-4h3c0.55 0 1-0.45 1-1v-5c0-0.55-0.45-1-1-1zM2 7c-0.552 0-1-0.448-1-1s0.448-1 1-1 1 0.448 1 1-0.448 1-1 1zM11 14h-6v-5h6v5z"
            ></path>
          </svg>
          <span>{{ $t("parcelshopPicker.parcelshopList.print") }}</span>
        </div>
      </template>
      <div v-if="isAmazonLocker(parcelshop)" class="amazon-locker-notice">
        {{ $t("parcelshopPicker.parcelshopList.amazonLockerNotice") }}
      </div>
      <div
        v-if="!isFocused && !disabledParcelshop"
        @click.stop="focusParcelshop(parcelshop)"
        @keydown.enter.prevent="focusParcelshop(parcelshop)"
        @keydown.space.prevent="focusParcelshop(parcelshop)"
        tabindex="0"
        class="plus-circle"
      >
        <!--<span class="icon-info"></span>-->
        <svg
          class="icon-info"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          width="40"
          height="40"
          viewBox="0 0 16 16"
        >
          <path
            d="M7 4.75c0-0.412 0.338-0.75 0.75-0.75h0.5c0.412 0 0.75 0.338 0.75 0.75v0.5c0 0.412-0.338 0.75-0.75 0.75h-0.5c-0.412 0-0.75-0.338-0.75-0.75v-0.5z"
          ></path>
          <path d="M10 12h-4v-1h1v-3h-1v-1h3v4h1z"></path>
          <path
            d="M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 14.5c-3.59 0-6.5-2.91-6.5-6.5s2.91-6.5 6.5-6.5 6.5 2.91 6.5 6.5-2.91 6.5-6.5 6.5z"
          ></path>
        </svg>
      </div>
    </div>
    <ParcelshopDetails
      v-if="isFocused"
      :parcelshop="parcelshop"
      :isSelectionModeEnabled="isSelectionModeEnabled"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import ParcelshopDetails from "../ParcelshopDetails/ParcelshopDetails";
import ParcelshopIcon from "../Icon/Parcelshop/ParcelshopIcon.vue";
import LockerIcon from "../Icon/Locker/LockerIcon.vue";
import AmazonLockerIcon from "../Icon/AmazonLocker/AmazonLockerIcon.vue";
import { isAmazonLocker, isLocker } from "../../utils/amazonLocker";

export default {
  data() {
    return {
      disabledParcelshop: false,
    };
  },
  mounted() {
    this.disabledParcelshop =
      isLocker(this.parcelshop) &&
      this.parcelshop.Numero == this.numeroUnavailableParcelshop;
  },
  components: {
    ParcelshopDetails,
    ParcelshopIcon,
    LockerIcon,
    AmazonLockerIcon,
  },
  props: {
    parcelshop: {
      type: Object,
      required: true,
    },
    price: {
      type: [Number, String],
      required: false,
    },
    parcelshopNumber: {
      type: Number,
      require: true,
    },
    numeroUnavailableParcelshop: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  computed: {
    ...mapState(["selectedParcelshopId", "isPrintInStoreHighlighted"]),
    isPriceModeEnabled: function () {
      return this.$store.state.params.isPriceModeEnabled;
    },
    isSelectionModeEnabled: function () {
      return this.$store.state.params.isSelectionModeEnabled;
    },
    isFocused: function () {
      return this.$store.state.focusedParcelshopId === this.parcelshop.Numero;
    },
    hasFocus: function () {
      return (
        this.$store.state.focusedParcelshopId == null ||
        this.$store.state.focusedParcelshopId === this.parcelshop.Numero
      );
    },
    isVisible: function () {
      if (this.$store.state.focusedParcelshopId != null) {
        return this.isFocused;
      }

      // Si pas de filtre sur print-in-store, pas de raison de cacher le point relais.
      if (!this.isPrintInStoreHighlighted) {
        return true;
      }

      // Si filtre print-in-store mais pas pas actif, pas de raison de cacher le point relais.
      if (!this.$store.state.isCountryPrintInStore) {
        return true;
      }

      // Si locker, on affiche pas (pas de print-in-store dans les lockers).
      if (isLocker(this.parcelshop)) {
        return false;
      }

      return (
        this.parcelshop.Services &&
        this.parcelshop.Services.some((e) => e.Code === "PRINT")
      );
    },
  },
  methods: {
    isAmazonLocker,
    isLocker,
    selectParcelshop: function (parselshop) {
      if (!parselshop.isUnavailable) {
        let formSubmit = document.querySelector(
          "#ECommerce_CreerEnvoi_Form_Submit"
        );
        if (formSubmit) {
          formSubmit.classList.remove("hide");
        }
        this.$store.commit("setSelectedParcelshopId", parselshop.Numero);
        this.$emit("parcelshop-selected", parselshop);
        let formInput = document.querySelector("#ECommerce_Livraison_PCL_ID");
        if (formInput) {
          formInput.value =
            parselshop.Adresse.Pays.Code + "-" + parselshop.Numero;
        }
      }

      let formInputFavoritePR = document.querySelector(
        "#Utilisateur_ModifierPointRelaisFavoris_Form_PCL_ID"
      );
      if (formInputFavoritePR) {
        formInputFavoritePR.value =
          parselshop.Adresse.Pays.Code + "-" + parselshop.Numero;
      }

      let _pricingData = null;
      let pricingId = null;
      if (this.$store.state.pricingData) {
        _pricingData = this.$store.state.pricingData;
        pricingId = _pricingData.pricingId;
      }
      if (!parselshop.isUnavailable) {
        window.dispatchEvent(
          new CustomEvent(
            "mondial-relay.parcelshop-picker-events.selected-parcelshop",
            {
              detail: {
                parcelshop: {
                  numero: parselshop.Numero,
                  country: parselshop.Adresse.Pays.Code,
                },
                pricing: {
                  id: pricingId,
                },
              },
            }
          )
        );
      }
    },

    isPrintInStore: function (parcelshop) {
      return (
        parcelshop.Services &&
        parcelshop.Services.some((e) => e.Code === "PRINT")
      );
    },
    focusParcelshop: function (parcelshop) {
      this.$store.dispatch("focusParcelshop", {
        parcelshopId: parcelshop.Numero || null,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.disabledParcelshop {
  .parcelshop-card-body {
    background-color: #a0a0a0 !important;

    .card-title {
      color: #383838 !important;
    }
  }
}
.selection-mode {
  .card-body {
    padding-left: 60px;
    position: relative;

    .pickup-selector {
      display: block;
      width: 26px;
      height: 26px;
      position: absolute;
      top: 54px;
      transform: translateY(-50%);
      cursor: pointer;
      -moz-border-radius: 50%;
      border-radius: 50%;
      background-color: #c1c6ca;
      border: solid 3px #eef0f3;
      left: 15px;

      &.selected {
        background-color: #3ecf8e;

        &::before {
          content: "\e936";
          color: #fff;
          font-family: icomoon;
          font-size: 3.1rem;
          display: block;
          width: 100%;
          float: left;
          margin-left: -5px;
          margin-top: -5px;
          font-style: normal;
        }
      }
    }
  }
}

.card-body {
  padding: 15px;
  text-align: left;

  transition: all 0.2s, top 0s, left 0s, width 0s, height 0s;
  -moz-transition: all 0.2s, top 0s, left 0s, width 0s, height 0s;
  -webkit-transition: all 0.2s, top 0s, left 0s, width 0s, height 0s;
  -o-transition: all 0.2s, top 0s, left 0s, width 0s, height 0s;
  -ms-transition: all 0.2s, top 0s, left 0s, width 0s, height 0s;
}

.card-container {
  display: flex;
  gap: 8px;
}

.card-title,
.card-footer,
.card-text,
.card-number {
  line-height: 24px;
  //text-transform: uppercase;
}

.card-text {
  font-weight: 400;
}

.card-title {
  font-weight: 700;
}

// Specificity above the theme rule `div.card div.card-body .card-title`
div.card div.card-body .card-title.card-title--amazon {
  color: #341661;
}

.amazon-locker-notice {
  font-weight: 700;
  font-size: 1.1rem;
  color: #341661;
  padding-top: 5px;
}

.card-footer {
  font-weight: 500;
  font-size: 1.1rem;
}

.card-number {
  font-weight: 700;
  font-size: 1rem;
  float: right;
  padding-left: 3px;
  color: #999;

  &--price {
    background-color: #d1d8de;
    padding: 0.3rem 0.9rem;
    font-size: 1.4rem;
    color: #ffffff;
    width: auto;
    font-weight: bold;
  }
}

.parcelshop-number {
  text-align: center;
  padding: 0 10px;
  padding-bottom: 0 !important;
  float: left;
  display: block;
  margin: 0 10px 0 0;
}

.details {
  position: absolute;
  padding-right: 15px;
  width: 100%;
  height: 100%;
}

.unavailable {
  font-weight: bold;
  font-size: 1.1rem;
  text-transform: uppercase;
  text-size-adjust: 100%;
  padding-top: 5px;
  padding-bottom: 5px;
}

.icon-info {
  font-size: 4rem;
  float: right;
  margin-top: -3.5rem;
  margin-right: 0;
}

.icon-info:hover {
  cursor: pointer;
}

.icon-barcode,
.icon-qrcode {
  color: black;
  font-size: 2rem;
  padding: 3px;
  vertical-align: middle;

  & ~ span {
    padding-left: 3px;
    vertical-align: middle;
  }
}
</style>
